export enum enumIsfQuickFixStep {
  CONSIGNEE_DETAILS,
  BUYER_DETAILS,
  SHIP_TO_DETAILS,
  SUPPLIER_DETAILS,
  CONSOLIDATOR_DETAILS,
  CONTAINER_STUFFING_LOCATION_DETAILS,
  MANUFACTURER_DETAILS,
  INTERNATIONAL_HTS_CODE_DETAILS,
  BILL_OF_LADING_DETAILS,
}
